import React, { useEffect, useState, useRef } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../services/firebase";
import LoadingSpinner from "../LoadingSpinner";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { ReactComponent as FileIcon } from '../../assets/icons/FileIcon.svg';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import { ReactComponent as EditIcon } from '../../assets/icons/EditIcon.svg';
import { useNavigate } from "react-router-dom";
import { useCotizaciones, aPesos } from "../../services/cotizaciones";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import GuiaEnvio from "../GuiaEnvio";
// Símbolo real de cada venta según su tipoDivisa — antes esta columna mostraba
// "$" fijo aunque la venta estuviera cargada en Dólares/Reales/Euros.
const SIMBOLOS_DIVISA = { Pesos: "$", "Dólares": "US$", Reales: "R$", Euros: "€" };
const opcionesPeriodo = [
{ id: "semanal", label: "Monto total semanal" },
{ id: "mensual", label: "Monto total mensual" },
{ id: "trimestral", label: "Monto total trimestral" },
{ id: "semestral", label: "Monto total semestral" },
{ id: "anual", label: "Monto total anual" },
{ id: "historico", label: "Monto total histórico" },
];
const Tooltip = ({ doc, children, type = "nombre", delay = 250, offsetX = 0, offsetY = 0 }) => {
const [isHovered, setIsHovered] = useState(false);
const [coords, setCoords] = useState({ top: 0, left: 0 });
const ref = React.useRef();
const timeoutRef = React.useRef();
const formatDateTime = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
const day = String(date.getDate()).padStart(2, "0");
const month = String(date.getMonth() + 1).padStart(2, "0");
const year = date.getFullYear();
const hours = String(date.getHours()).padStart(2, "0");
const minutes = String(date.getMinutes()).padStart(2, "0");
return `el ${day}/${month}/${year} a las ${hours}:${minutes}`;
};
const handleMouseEnter = () => {
const rect = ref.current.getBoundingClientRect();
setCoords({
top: rect.bottom + window.scrollY + 5 + offsetY,
left: rect.left + rect.width / 2 + window.scrollX + offsetX,
});
timeoutRef.current = setTimeout(() => setIsHovered(true), delay);
};
const handleMouseLeave = () => {
clearTimeout(timeoutRef.current);
setIsHovered(false);
};
const renderContent = () => {
switch (type) {
case "nombre":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
<div>
<strong style={{color: '#999', fontSize:'13px', fontFamily:'Effra', fontWeight:'normal'}}>
{doc.personeria === "persona fisica"
? `${(doc.apellido || '').toUpperCase()}, ${doc.nombre || ""}`
: doc.razonSocial || ""}
</strong></div>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra'}}>
Creado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{doc.creador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(doc.fechaCreacion)}</p>
{doc.modificador && (
<>
<hr style={{borderColor:'#ebeef2'}}></hr>
Modificado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{doc.modificador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(doc.fecha_modificacion || doc.ultimaActualizacion)}</p>
</>
)}</div>
</div>
</>
);
case "domicilio":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px',textAlign:'left' }}>
<div>
<strong style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra',textAlign:'left', fontWeight:'normal'}}>
{doc.calle}  {doc.altura}, {doc.piso}{doc.unidad}
</strong></div>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra', textAlign:'left'}}>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}> {doc.codigoPostal}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}> {doc.ciudad}, {doc.pais}</p>
</div>
</div>
</>
);
case "correo":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px',textAlign:'left' }}>
<div>
<strong style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra',textAlign:'left', fontWeight:'normal'}}>
{doc.correoElectronico}
</strong></div>
</div>
</>
);
case "creador": 
return (
<>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra'}}>
Creado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{doc.creador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(doc.fechaVenta)}</p>
</div>
</>
);
default:
return null;
}
};
return (
<>
<div
ref={ref}
style={{ display: "inline-block" }}
onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave}
>
{children}
</div>
{isHovered && (
<div
style={{
position: "absolute",
top: coords.top,
backgroundColor: "#f9fafd",
padding: "8px 12px",
borderRadius: "4px",
whiteSpace: "normal",
zIndex: 1000,
fontSize: "14px",
minWidth: "200px",
pointerEvents: "none",
boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
}}
>
{renderContent()}
</div>
)}
</>
);
};
// Ícono de impresora simple, inline (no hay un asset dedicado todavía).
// Mismo color que FileIcon.svg (fill: #2c2c2c) — acá vía currentColor, ya
// que este ícono es de trazo (stroke) en vez de relleno.
const PrintIcon = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" {...props}>
<path stroke="none" d="M0 0h24v24H0z" fill="none" />
<path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
<path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
<path d="M7 15a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2l0 -4" />
</svg>
);
// Fuera del componente para que sobreviva a que se desmonte al navegar (ej.
// al editar una venta y volver): guarda la última lista bajada de Firestore
// para poder mostrarla de entrada la próxima vez, en vez de arrancar siempre
// en blanco con el spinner tapando la pantalla mientras se vuelve a bajar.
let ventasCache = null;
const Ventas = () => {
const navigate = useNavigate();
const [ventas, setVentas] = useState(ventasCache?.ventas || []);
const [recientes, setRecientes] = useState(ventasCache?.recientes || []);
const [loading, setLoading] = useState(!ventasCache);
const [activeTab, setActiveTab] = useState('persona fisica');
const [sortField, setSortField] = useState('');
const [sortOrder, setSortOrder] = useState('desc');
// Monto total del período mezcla ventas en distintas divisas: se pasan
// todas a Pesos antes de sumar (antes se sumaba totalFinal crudo, como si
// una venta en Dólares "pesara" lo mismo en pesos que en dólares).
const { cotizaciones } = useCotizaciones();
const obtenerUrlFactura = async (venta) => {
const numeroFactura = venta.numeroFactura || venta.id;
if (!numeroFactura) return null;
const storage = getStorage();
const facturaRef = ref(storage, `facturas/${numeroFactura}.pdf`);
try {
const url = await getDownloadURL(facturaRef);
return url;
} catch (error) {
console.error("Error al obtener la URL de la factura:", error);
return null;
}
};
// Mientras el pedido está en proceso miramos la nota de pedido; una vez entregado
// lo que importa es el comprobante fiscal. El número de nota no se deriva del de
// factura (son dos secuencias independientes), así que sale del puntero
// 'notaPedidoId' que deja el backend al crear la venta.
const obtenerUrlNotaPedido = async (venta) => {
if (!venta.notaPedidoId) return null;
const storage = getStorage();
const notaRef = ref(storage, `notas_pedido/${venta.notaPedidoId}.pdf`);
try {
return await getDownloadURL(notaRef);
} catch (error) {
console.error("Error al obtener la URL de la nota de pedido:", error);
return null;
}
};
// Guía de envío: se genera al vuelo, no se sube a Storage (a diferencia de
// factura/remito).
const [imprimiendoId, setImprimiendoId] = useState(null);
const [guiaAImprimir, setGuiaAImprimir] = useState(null);
const guiaRefs = useRef([]);
// Sin estos datos la guía queda inservible (no solo incompleta): sin cliente
// no hay a quién rotular, sin domicilio no hay adónde entregar, sin
// transportista no se sabe quién retira, sin bultos no hay nada que rotular,
// y sin despachante no queda registro de quién lo hizo. 'bultosTotales' y
// 'despachante' son campos cargados a mano en 'datosEnvio' —el primero no se
// deriva de 'insumos.cajaX6' (esas son las cajas de 6 que se usaron para
// embalar, un dato de stock; al despachar, dos cajas pueden ir atadas como un
// solo bulto), y el segundo ya no se infiere de quién apretó "Imprimir".
// CUIT/DNI, teléfono y observaciones son opcionales — si faltan, van en
// blanco en el PDF.
const motivoNoImprimible = (venta) => {
if (!venta.cliente) return "Falta cargar los datos del cliente.";
if (!venta.direccionEntrega?.calle) return "Falta el domicilio de entrega.";
if (!venta.datosEnvio?.empresaTransporte) return "Falta cargar la empresa de transporte.";
if (!(Number(venta.datosEnvio?.bultosTotales) > 0)) return "Falta cargar la cantidad de bultos totales.";
if (!venta.datosEnvio?.despachante) return "Falta cargar el despachante.";
return null;
};
// La pestaña se abre acá, en el mismo tick del click — si se abre después de
// algún await, el navegador ya no lo asocia al gesto del usuario y la
// bloquea como popup (se ve como si mandara a about:blank). Se le carga el
// PDF recién cuando está listo, en el useEffect de más abajo.
const ventanaImpresionRef = useRef(null);
const handleImprimirGuia = (venta) => {
ventanaImpresionRef.current = window.open('', '_blank');
setImprimiendoId(venta.id);
const despachadoPor = venta.datosEnvio?.despachante || '-';
const cantidadBultos = Number(venta.datosEnvio?.bultosTotales) || 1;
guiaRefs.current = [];
setGuiaAImprimir({ venta, despachadoPor, cantidadBultos });
};
// Cuando 'guiaAImprimir' cambia, ya se renderizaron (ocultas) las N páginas
// de GuiaEnvio — una por bulto — con sus refs cargados en guiaRefs. Recién
// ahí se puede rasterizar cada una con html2canvas, igual que
// generarPDFMultiComponente en VentasForm.js con factura+remito.
useEffect(() => {
if (!guiaAImprimir) return;
const generar = async () => {
try {
// Cada página es media A4 vertical (210 x 148.5mm) — una guía por bulto,
// no una A4 entera. GuiaEnvio.jsx ya mide exactamente eso.
const PAGE_WIDTH_MM = 210;
const PAGE_HEIGHT_MM = 148.5;
const pdf = new jsPDF('l', 'mm', [PAGE_HEIGHT_MM, PAGE_WIDTH_MM]);
for (let i = 0; i < guiaAImprimir.cantidadBultos; i++) {
const input = guiaRefs.current[i];
if (!input) continue;
const canvas = await html2canvas(input, { scale: 2, useCORS: true });
const imgData = canvas.toDataURL('image/png');
if (i > 0) pdf.addPage([PAGE_HEIGHT_MM, PAGE_WIDTH_MM], 'l');
pdf.addImage(imgData, 'PNG', 0, 0, PAGE_WIDTH_MM, PAGE_HEIGHT_MM);
}
const blobUrl = pdf.output('bloburl');
const ventana = ventanaImpresionRef.current;
if (ventana && !ventana.closed) {
ventana.location.href = blobUrl;
} else {
// Se bloqueó el popup al abrirlo vacío (o el usuario lo cerró mientras
// se generaba): se reintenta directo con la URL ya lista, que al menos
// en algunos navegadores sigue sin bloquearse por venir de un click.
window.open(blobUrl, '_blank');
}
} catch (error) {
console.error("Error al generar la guía de envío:", error);
alert("No se pudo generar la guía de envío.");
} finally {
setGuiaAImprimir(null);
setImprimiendoId(null);
}
};
generar();
}, [guiaAImprimir]);
const estaEntregada = (venta) => venta.estado === 'Entregado';
// Las ventas viejas no tienen nota de pedido: ahí se cae a la factura en vez de
// dejar la fila sin nada para abrir.
const mostrarNotaDePedido = (venta) => !estaEntregada(venta) && !!venta.notaPedidoId;
const obtenerUrlComprobante = async (venta) => (
mostrarNotaDePedido(venta)
? await obtenerUrlNotaPedido(venta)
: await obtenerUrlFactura(venta)
);
const fetchData = async () => {
try {
const ventasQuery = query(collection(db, "ventas"), orderBy("fechaVenta", "desc"));
const ventasSnap = await getDocs(ventasQuery);
const ventasData = ventasSnap.docs.map((doc) => ({
id: doc.id,
...doc.data(),
}));
const recientesFinal = ventasData.slice(0, 4);
setVentas(ventasData);
setRecientes(recientesFinal);
// Se guarda para que la próxima vez que se entre a esta pantalla (ej.
// volviendo de guardar una venta) se muestre esta lista al toque, en vez
// de tapar todo con el spinner mientras se recarga en segundo plano.
ventasCache = { ventas: ventasData, recientes: recientesFinal };
} catch (error) {
console.error("Error al traer datos de ventas:", error);
} finally {
setLoading(false);
}
};
useEffect(() => {
fetchData();
}, []);
const [periodo, setPeriodo] = useState(opcionesPeriodo[5]); 
const calcularMonto = (ventas, periodo) => {
const ahora = new Date();
let fechaInicio;
switch (periodo.id) {
case "semanal":
fechaInicio = new Date();
fechaInicio.setDate(ahora.getDate() - 7);
break;
case "mensual":
fechaInicio = new Date();
fechaInicio.setMonth(ahora.getMonth() - 1);
break;
case "trimestral":
fechaInicio = new Date();
fechaInicio.setMonth(ahora.getMonth() - 3);
break;
case "semestral":
fechaInicio = new Date();
fechaInicio.setMonth(ahora.getMonth() - 6);
break;
case "anual":
fechaInicio = new Date();
fechaInicio.setFullYear(ahora.getFullYear() - 1);
break;
case "historico":
default:
fechaInicio = null;
break;
}
return ventas.reduce((total, venta) => {
const fechaVenta = venta.fechaVenta?.toDate
? venta.fechaVenta.toDate()
: new Date(venta.fechaVenta);
if (!fechaInicio || fechaVenta >= fechaInicio) {
return total + aPesos(venta.totalFinal, venta.tipoDivisa, cotizaciones);
}
return total;
}, 0);
};
const montoSeleccionado = calcularMonto(ventas, periodo);
if (loading) return <LoadingSpinner />;
const handleSort = (field) => {
if (sortField === field) {
setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
} else {
setSortField(field);
setSortOrder('asc');
}
};
const formatearFecha = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
return date.toLocaleDateString("es-AR");
};
const formatearFechaYHora = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
const dia = date.getDate().toString().padStart(2, '0');
const mes = (date.getMonth() + 1).toString().padStart(2, '0');
const anio = date.getFullYear();
const horas = date.getHours().toString().padStart(2, '0');
const minutos = date.getMinutes().toString().padStart(2, '0');
return `El ${dia}/${mes}/${anio} a las ${horas}:${minutos}`;
};
// "Envíos" no es una tercera categoría de cliente: es un filtro sobre el
// mismo listado (requiere_envio = true), sean físicas o jurídicas. La venta
// sigue viviendo en un solo doc, y puede aparecer en Físicas/Jurídicas Y en
// Envíos a la vez.
let ventasParaMostrar = activeTab === 'envios'
? ventas.filter(v => v.requiere_envio === true)
: ventas.filter(v => v.cliente && v.cliente.personeria === activeTab);
ventasParaMostrar.sort((a, b) => {
let aValue;
let bValue;
switch (sortField) {
case 'cliente':
aValue = (a.cliente?.personeria === 'persona fisica' ? (a.cliente?.apellido || '').toUpperCase() : (a.cliente?.razonSocial || '').toUpperCase());
bValue = (b.cliente?.personeria === 'persona fisica' ? (b.cliente?.apellido || '').toUpperCase() : (b.cliente?.razonSocial || '').toUpperCase());
break;
case 'fechaVenta':
aValue = new Date(a.fechaVenta).getTime();
bValue = new Date(b.fechaVenta).getTime();
break;
case 'totalFinal':
aValue = a.totalFinal || 0;
bValue = b.totalFinal || 0;
break;
case 'modalidadPago':
aValue = (a.modalidadPago || '').toLowerCase();
bValue = (b.modalidadPago || '').toLowerCase();
break;
case 'empresaTransporte':
aValue = (a.datosEnvio?.empresaTransporte || '').toLowerCase();
bValue = (b.datosEnvio?.empresaTransporte || '').toLowerCase();
break;
case 'numeroGuia':
aValue = (a.datosEnvio?.numeroGuia || '').toLowerCase();
bValue = (b.datosEnvio?.numeroGuia || '').toLowerCase();
break;
case 'fechaDespacho':
aValue = a.datosEnvio?.fechaDespacho || '';
bValue = b.datosEnvio?.fechaDespacho || '';
break;
default:
aValue = a[sortField];
bValue = b[sortField];
}
if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
return 0;
});
const columnas = [
{
id: 'id',
header: 'ID de la venta',
width: '10%',
render: (venta) => (
<Tooltip 
doc={venta} 
type="creador" 
delay={50} 
offsetX={-50} 
offsetY={0} 
>
{}
<span style={{ cursor: 'pointer' }}>
{venta.id || '-'}
</span>
</Tooltip>
) 
},
{ id: 'fechaVenta', header: 'Fecha de la venta', render: (venta) => formatearFecha(venta.fechaVenta) },
{ id: 'totalFinal',header: 'Monto total', render: (venta) => `${SIMBOLOS_DIVISA[venta.tipoDivisa] || '$'}${venta.totalFinal ? Math.floor(venta.totalFinal).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0, }) : '-'}`},
{ id: 'modalidadPago', header: 'Modalidad de pago', render: (venta) => venta.modalidadPago || '-' },
{
id: 'cliente',
header: 'Cliente',
render: (venta) => venta.cliente?.personeria === 'persona fisica'
? `${(venta.cliente.apellido || '-').toUpperCase()}, ${venta.cliente.nombre || '-'}`
: venta.cliente?.razonSocial || '-'
},
{
id: 'verFactura',
header: 'Comprobante',
render: (venta) => {
const tieneNota = !!venta.notaPedidoId;
const documentoDisponible = tieneNota || venta.numeroFactura || venta.id;
return (
<div
onClick={documentoDisponible ? async (e) => {
e.stopPropagation();
// Las pestañas se abren acá, vacías y en el mismo tick del click, para
// que el navegador las asocie al gesto del usuario — si se abrieran
// después del await, las bloquea como popup (igual que handleImprimirGuia).
const ventanaNota = tieneNota ? window.open('', '_blank') : null;
const ventanaFactura = window.open('', '_blank');
const [urlNota, urlFactura] = await Promise.all([
tieneNota ? obtenerUrlNotaPedido(venta) : Promise.resolve(null),
obtenerUrlFactura(venta)
]);
if (urlNota) ventanaNota.location.href = urlNota;
else ventanaNota?.close();
if (urlFactura) ventanaFactura.location.href = urlFactura;
else ventanaFactura.close();
if (!urlNota && !urlFactura) alert("No se pudo obtener la nota de pedido ni la factura.");
} : null}
style={{ cursor: documentoDisponible ? 'pointer' : 'default' }}
>
<FileIcon
title={documentoDisponible ? [tieneNota ? `Nota de pedido ${venta.notaPedidoId}` : null, `Factura ${venta.id}`].filter(Boolean).join(' / ') : undefined}
style={{ height: "20px", width: "20px", margin:'auto', opacity: documentoDisponible ? 1 : 0.5, overflow:'visible' }}
/>
</div>
);
}
},
{
id: 'estado',
header: 'Estado',
width: '10%',
render: (venta) => {
const entregado = venta.estado === 'Entregado';
return (
<span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
<span className={`status-circle ${entregado ? 'green' : 'yellow'}`}></span>
<span className="status-text">{entregado ? 'Entregado' : 'Pendiente'}</span>
</span>
);
}
}
];
// Envíos muestra otras columnas — lo operativo del despacho en vez de monto
// y modalidad de pago — pero reusa el mismo 'estado' de siempre (Pendiente/
// Entregado): no se suman estados intermedios.
const columnasEnvios = [
// Clonada (no la referencia tal cual) para achicarla solo en Envíos, sin
// afectar el ancho de 'id' en Físicas/Jurídicas.
{ ...columnas.find(c => c.id === 'id'), width: '9.6%' },
// El header (<thead>) y cada fila (<tbody> tr) son tablas independientes
// entre sí por el CSS del sticky header (display:table en cada una) — así
// que ninguna columna puede quedar "sin ancho definido": si el navegador
// tiene que repartir el resto a su criterio, el header y las filas lo
// hacen cada uno por su cuenta y no necesariamente coinciden. Por eso las
// 7 columnas de esta tabla llevan un width explícito, sin excepción — y
// deben sumar 100% junto con la columna de acciones (4%, ver más abajo en
// el <th>/<td> "col-editar"): si sobra o falta ancho, el navegador lo
// reparte distinto en el thead que en cada fila y quedan desalineados.
{ ...columnas.find(c => c.id === 'cliente'), width: '16%' },
{
id: 'empresaTransporte',
header: 'Empresa de transporte',
width: '16%',
render: (venta) => venta.datosEnvio?.empresaTransporte || '-'
},
{
id: 'numeroGuia',
header: 'N° de guía',
width: '16%',
render: (venta) => venta.datosEnvio?.numeroGuia || '-'
},
{
id: 'fechaDespacho',
header: 'Fecha de despacho',
width: '15.4%',
render: (venta) => venta.datosEnvio?.fechaDespacho ? formatearFecha(venta.datosEnvio.fechaDespacho) : '-'
},
{
id: 'comprobanteEnvio',
header: 'Comprobante',
width: '11.5%',
render: (venta) => {
const url = venta.datosEnvio?.archivoUrl;
return (
<div
onClick={url ? (e) => { e.stopPropagation(); window.open(url, '_blank'); } : null}
style={{ cursor: url ? 'pointer' : 'default' }}
>
<FileIcon
title={url ? "Etiqueta / guía de envío" : undefined}
style={{ height: "20px", width: "20px", margin:'auto', opacity: url ? 1 : 0.5, overflow:'visible' }}
/>
</div>
);
}
},
// No es la misma columna 'estado' de Físicas/Jurídicas: acá, al lado de
// "Entregado", va el ícono de imprimir la guía — no tiene sentido antes
// (nada para despachar todavía) y no aparece en las otras pestañas (ahí no
// hay guía de envío que imprimir).
{
id: 'estado',
header: 'Estado',
width: '11.5%',
render: (venta) => {
const entregado = venta.estado === 'Entregado';
return (
<span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
<span className={`status-circle ${entregado ? 'green' : 'yellow'}`}></span>
<span className="status-text">{entregado ? 'Entregado' : 'Pendiente'}</span>
</span>
);
}
},
];
const columnasActivas = activeTab === 'envios' ? columnasEnvios : columnas;
return (
<div className="Trazabilidad">
<header className="trazabilidad-header">
<div className="header-content">
<h1>Ventas</h1>
</div>
</header>
<div className="trazabilidad-content">
<div className="section">
<h2>Recientes</h2>
{recientes.length === 0 ? (
<p>No hay ventas recientes.</p>
) : (
<div className="recent-grid">
{recientes.map((venta) => (
<div
key={venta.id}
className="document-card recent-card"
onClick={async () => {
const url = await obtenerUrlComprobante(venta);
if (url) {
window.open(url, '_blank');
} else {
alert("No se pudo obtener el comprobante.");
}
}}
style={{
flexDirection: "column",
textAlign: "left",
alignItems: "start",
justifyContent: "start",
gap: "2px",
cursor: "pointer",
}}
>
<span className="doc-id" style={{ margin: 0 }}>
{venta.id || ''}
</span>
<p className="card-date" style={{ margin: 0, textTransform: 'capitalize' }}>
{venta.creador || ''}
</p>
<p className="card-date" style={{ margin: 0 }}>
{formatearFechaYHora(venta.fechaVenta)}
</p>
</div>
))}
</div>
)}
</div>
<div
className="monto-historico"
>
<div className="input-group">
<Listbox value={periodo} onChange={setPeriodo}>
{({ open }) => (
<>
<ListboxButton 
className={`monto-listbox-button ${open ? 'open' : ''}`} 
style={{ textAlign: 'center' }}
>
{periodo.label}
<span className="monto-arrow-container">
<span className="monto-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="monto-listbox-options">
{opcionesPeriodo.map((op) => (
<ListboxOption
key={op.id}
value={op}
className="monto-listbox-option"
>
{op.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<p style={{ margin: "0" }}>
${montoSeleccionado.toLocaleString("es-AR", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
</p>
</div>
<ul className="clientes-tabs">
<li className={activeTab === "persona fisica" ? "active" : ""}>
<a
href="#"
onClick={(e) => {
e.preventDefault();
setActiveTab("persona fisica");
}}
>Físicas
</a>
</li>
<li className={activeTab === "persona juridica" ? "active" : ""}>
<a
href="#"
onClick={(e) => {
e.preventDefault();
setActiveTab("persona juridica");
}}
>Jurídicas
</a>
</li>
<li className={activeTab === "envios" ? "active" : ""}>
<a
href="#"
onClick={(e) => {
e.preventDefault();
setActiveTab("envios");
}}
>Envíos
</a>
</li>
</ul>
<div className="section">
{ventasParaMostrar.length === 0 ? (
<p>No hay ventas de este tipo para mostrar.</p>
) : (
<div className="table-container">
<table className="table-full" style={{ textAlign: 'center' }}>
<thead>
<tr>
{/* Columna del lapicito (y, en Envíos, la impresora): sin encabezado, del ancho de los íconos. */}
<th className="col-editar" style={activeTab === 'envios' ? { width: '4%' } : undefined}></th>
{columnasActivas.map((col, index) => {
const noOrdenable = col.id === 'verFactura' || col.id === 'comprobanteEnvio';
// Misma condición que usa el <td> de abajo (index === 0 || estado ||
// totalFinal): si no coinciden, el header queda alineado distinto que la
// celda y se ve desalineado.
const alineadoIzquierda = index === 0 || col.id === 'estado';
const alineadoDerecha = col.id === 'totalFinal';
const justify = alineadoIzquierda ? 'flex-start' : alineadoDerecha ? 'flex-end' : 'center';
const textAlign = alineadoIzquierda ? 'left' : alineadoDerecha ? 'right' : 'center';
return (
<th
key={col.id}
style={{ fontFamily: 'Effra', fontWeight: '600', cursor: !noOrdenable ? 'pointer' : 'default', margin: '0 auto', textAlign,fontSize:'15px', zIndex:'0', ...(alineadoDerecha ? { paddingRight: '50px' } : {}), ...(col.width ? { width: col.width } : {}) }}
onClick={() => { if (!noOrdenable) { handleSort(col.id); } }}
>
<div style={{ display: 'flex', alignItems: 'center', justifyContent: justify, gap: '5px', textAlign, margin: alineadoIzquierda ? '0' : '0 auto' }}>
{col.header} {sortField === col.id && !noOrdenable && (  <span className={`arrow ${sortOrder}`}></span>)}</div>
</th>
);
})}
</tr>
</thead>
<tbody>
{/* '.table-row' trae cursor:pointer por CSS (se comparte con Clientes/Compras/
Stock) — acá la fila ya no abre nada al clickear, así que se pisa acá nomás,
sin tocar la clase global. */}
{ventasParaMostrar.map((venta) => (
<tr className="table-row" style={{ cursor: 'default' }} key={venta.id}>
<td className="col-editar" style={activeTab === 'envios' ? { width: '4%' } : undefined}>
<span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
<button
onClick={(e) => { e.stopPropagation(); navigate(`/ventas/editar/${venta.id}`); }}
title="Editar venta"
style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'inline-flex', alignItems: 'center' }}
>
<EditIcon style={{ width: '16px', height: '16px' }} />
</button>
{activeTab === 'envios' && (() => {
const motivo = motivoNoImprimible(venta);
const deshabilitado = !!motivo || imprimiendoId !== null;
return (
<button
type="button"
onClick={(e) => { e.stopPropagation(); if (!deshabilitado) handleImprimirGuia(venta); }}
disabled={deshabilitado}
title={motivo || "Imprimir guía de envío"}
style={{ background: 'none', border: 'none', cursor: deshabilitado ? 'default' : 'pointer', padding: 0, display: 'inline-flex', alignItems: 'center', opacity: deshabilitado ? 0.4 : 1 }}
>
<PrintIcon style={{ width: '22px', height: '20px', color: '#2c2c2c' }} />
</button>
);
})()}
</span>
</td>
{columnasActivas.map((col, index) => (
<td
key={col.id}
// Ninguna celda abre nada al clickear por su cuenta: lo único
// clickeable es el ícono de las columnas 'verFactura'/'comprobanteEnvio'
// (cada una maneja su propio click en su render, con stopPropagation).
style={{
...(col.id === 'totalFinal' ? { paddingRight: '50px' } : {}),
textAlign: (index === 0 || col.id === 'estado')
? 'left'
: (col.id === 'totalFinal')
? 'right'
: 'center',
whiteSpace: "nowrap",
overflow: "hidden",
textOverflow: "ellipsis",
verticalAlign: "middle",
...(col.width ? { width: col.width } : {}),
}}
>
{col.render(venta)}
</td>
))}
</tr>
))}
</tbody>
</table>
</div>
)}
</div>
</div>
{guiaAImprimir && (
<div style={{ position: 'fixed', top: 0, left: 0, width: 0, height: 0, overflow: 'hidden' }}>
{Array.from({ length: guiaAImprimir.cantidadBultos }).map((_, i) => (
<GuiaEnvio
key={i}
ref={(el) => { guiaRefs.current[i] = el; }}
cliente={guiaAImprimir.venta.cliente}
direccionEntrega={guiaAImprimir.venta.direccionEntrega}
empresaTransporte={guiaAImprimir.venta.datosEnvio?.empresaTransporte}
observaciones={guiaAImprimir.venta.direccionEntrega?.observaciones}
despachadoPor={guiaAImprimir.despachadoPor}
cantidadBultos={guiaAImprimir.cantidadBultos}
bultoNumero={i + 1}
/>
))}
</div>
)}
</div>
);
};
export default Ventas;